import React, { useRef } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useMemoizedFn, useMount, useSafeState, useUnmount } from "ahooks";
dayjs.extend(duration);
/**
 * @param {Object} props
 * @param {string|number|Date|dayjs} props.targetTime dayjs.js 可识别的时间数据
 * @param {(duration: Duration) => string =} props.formatter 倒计时格式化器
 * @param {() => void =} props.onTimeout 倒计时结束回调
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
export default function CountDown({
  targetTime,
  formatter,
  onTimeout,
  ...rest
}) {
  const [duration, setDuration] = useSafeState();
  const taskId = useRef();
  const defaultFormatter = useMemoizedFn((duration) => {
    const pad = (v) => v.toString().padStart(2, "0");
    return duration.asMilliseconds() > 0
      ? `${pad(duration.hours())}:${pad(duration.minutes())}:${pad(
          duration.seconds()
        )}`
      : "00:00:00";
  });

  formatter = formatter ?? defaultFormatter;

  const counter = useMemoizedFn(() => {
    const ms = dayjs(targetTime).toDate().getTime() - Date.now();
    setDuration(dayjs.duration(ms));
    if (ms < 0 && taskId.current) {
      onTimeout && onTimeout();
      clearInterval(taskId.current);
      taskId.current = null;
    }
  });

  useMount(() => {
    const ms = dayjs(targetTime).toDate().getTime() - Date.now();
    if (ms <= 0) {
      counter();
      return;
    }
    taskId.current = setInterval(() => {
      counter();
    }, 1000);
    counter();
  });

  useUnmount(() => {
    if (taskId.current) clearInterval(taskId.current);
  });

  return duration ? <div {...rest}>{formatter(duration)}</div> : null;
}
